import type { PropsWithChildren, ReactNode } from "react";
import { tv } from "tailwind-variants";

const emptyStateVariants = tv({
  slots: {
    root: "flex flex-col items-center justify-center gap-3 px-6 py-12 text-center",
    iconWrapper:
      "flex size-12 items-center justify-center rounded-full bg-surface-sunken text-content-subtle",
    title: "text-sm font-medium text-content-strong",
    description: "max-w-sm text-sm text-content-muted",
  },
});

const {
  description: descriptionClass,
  iconWrapper,
  root,
  title: titleClass,
} = emptyStateVariants();

type EmptyStateProps = {
  title: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
};

/*
  Shared so "nothing here yet" reads the same everywhere. Empty tables and empty
  threads were each a bare line of centred text in a large blank panel.
*/
export const EmptyState = ({
  children,
  className,
  description,
  icon,
  title,
}: PropsWithChildren<EmptyStateProps>) => {
  return (
    <div className={root({ className })}>
      {icon ? (
        <div aria-hidden="true" className={iconWrapper()}>
          {icon}
        </div>
      ) : null}

      <p className={titleClass()}>{title}</p>

      {description ? <p className={descriptionClass()}>{description}</p> : null}

      {children}
    </div>
  );
};
